// extracted by mini-css-extract-plugin
export default {"footer-main":"PNvDt","footer-logo":"ISi1m","footer-title":"Bsvrn","footer-description":"Q2Cis"};